module.exports = __webpack_public_path__ + "static/images/gift-bg.060c09a.png";